export const CHARTS_2_URL = 'charts'
export const CHARTS_2_DETAIL_URL = 'charts-detail'

export const CHARTS_2_TRANSACTION_PATH = `/project/:id/${CHARTS_2_URL}`
export const CHARTS_2_DETAIL_TRANSACTION_PATH = `/project/:id/${CHARTS_2_URL}/:chartsId`
